import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const LINKS = [
  ["About Us", "/about"], ["Contact Us", "/contact"], ["Pricing", "/pricing"], ["Privacy Policy", "/privacy"],
  ["Terms & Conditions", "/terms"], ["Refund & Cancellation Policy", "/refund-policy"], ["Data Deletion Policy", "/data-deletion"],
];

export function Footer() {
  return (
    <footer className="border-t border-ww-border bg-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 lg:grid-cols-[1.2fr_2fr] lg:px-8">
        <div>
          <Logo testid="footer-logo-link" />
          <p className="mt-4 max-w-xs text-sm text-ww-muted">Every Purchase. Every Promise. One Wallet.</p>
        </div>
        <nav className="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3" aria-label="Footer">
          {LINKS.map(([l, to]) => (
            <Link key={to} to={to} className="text-sm text-ww-navy/80 transition-colors hover:text-ww-emerald" data-testid={`footer-link-${to.slice(1)}`}>{l}</Link>
          ))}
        </nav>
      </div>
      <div className="border-t border-ww-border">
        <p className="mx-auto max-w-7xl px-5 py-5 text-xs text-ww-muted lg:px-8">
          © {new Date().getFullYear()} Warranty Wallet. Warranty Wallet stores documents and sends reminders; it does not issue, extend, guarantee or enforce manufacturers' warranties.
        </p>
      </div>
    </footer>
  );
}
